export default __webpack_public_path__ + "static/cointelegraph-a0c5c0644c0899a9e86096fd0e86f0bf.png";